import { MandatoryStar } from "../../../Utils/helper";

export const InputTextFieldComponent = ({
  heading,
  placeholder,
  name,
  handleChange,
  isPageEdit,
  values,
  errors,
  pageType,
  required,
}) => {
  return (
    <div className="col-lg-4 col-md-6">
      <div className="mb-4">
        <label className={`form-label ${pageType === "PaymentPage" && "mb-3"}`}>
          {heading}
        </label>
        {required && <MandatoryStar />}
        <input
          name={name}
          type="text"
          placeholder={placeholder}
          className="form-control"
          value={values}
          onChange={handleChange}
          disabled={!isPageEdit}
          onKeyPress={(e) => {
            const re = /[a-zA-Z ]+/g;
            if (!re.test(e.key)) {
              e.preventDefault();
            }
          }}
        />
        {errors && isPageEdit && (
          <div className="errorInputMessage">{errors}</div>
        )}
      </div>
    </div>
  );
};

export const InputFieldNumberComponent = ({
  heading,
  placeholder,
  name,
  handleChange,
  isPageEdit,
  values,
  errors,
  minLength,
  maxLength,
  pageType,
  required,
}) => {
  return (
    <div className="col-lg-4 col-md-6">
      <div className="mb-4">
        <label className={`form-label ${pageType === "PaymentPage" && "mb-3"}`}>
          {heading}
        </label>
        {required && <MandatoryStar />}
        <input
          name={name}
          type="text"
          minLength={minLength}
          maxLength={maxLength}
          placeholder={placeholder}
          className="form-control"
          value={values}
          onChange={handleChange}
          disabled={!isPageEdit}
          onKeyPress={(event) => {
            const re = /[0-9]+/g;
            if (!re.test(event.key)) {
              event.preventDefault();
            }
          }}
        />
        {errors && isPageEdit && (
          <div className="errorInputMessage">{errors}</div>
        )}
      </div>
    </div>
  );
};

export const InputFieldComponent = ({
  heading,
  placeholder,
  name,
  handleChange,
  isPageEdit,
  values,
  errors,
  pageType,
  required,
}) => {
  return (
    <div className="col-lg-4 col-md-6">
      <div className="mb-4">
        <label className={`form-label ${pageType === "PaymentPage" && "mb-3"}`}>
          {heading}
        </label>
        {required && <MandatoryStar />}
        <input
          name={name}
          type="text"
          placeholder={placeholder}
          className="form-control"
          value={values}
          onChange={handleChange}
          disabled={!isPageEdit}
        />
        {errors && isPageEdit && (
          <div className="errorInputMessage">{errors}</div>
        )}
      </div>
    </div>
  );
};
